export default "__VITE_ASSET__CObLGM_W__"